// src/components/mediaKit/LayoutPreviewCard.jsx
import React, { useState } from 'react';
import { Layout } from 'lucide-react';

const MINI_MOCKUPS = {
    aurora: (
        <svg viewBox="0 0 200 130" className="w-full h-full">
            <rect width="200" height="130" fill="#0b0f19" />
            <circle cx="30" cy="20" r="40" fill="#7c3aed" opacity="0.35" />
            <circle cx="170" cy="40" r="35" fill="#06b6d4" opacity="0.3" />
            <rect x="12" y="14" width="60" height="60" rx="10" fill="#ffffff12" stroke="#ffffff22" />
            <rect x="12" y="82" width="176" height="36" rx="10" fill="#ffffff10" />
        </svg>
    ),
    paperlight: (
        <svg viewBox="0 0 200 130" className="w-full h-full">
            <rect width="200" height="130" fill="#f8fafc" />
            <rect x="12" y="14" width="176" height="60" rx="12" fill="#fff" stroke="#e2e8f0" />
            <rect x="12" y="82" width="84" height="36" rx="10" fill="#fff" stroke="#e2e8f0" />
            <rect x="104" y="82" width="84" height="36" rx="10" fill="#fff" stroke="#e2e8f0" />
        </svg>
    ),
    editorial: (
        <svg viewBox="0 0 200 130" className="w-full h-full">
            <rect width="200" height="130" fill="#fff" />
            <rect x="12" y="14" width="176" height="4" fill="#111" />
            <rect x="12" y="26" width="120" height="10" fill="#111" />
            <rect x="12" y="42" width="176" height="1" fill="#e2e8f0" />
            <rect x="12" y="56" width="50" height="50" fill="#f1f5f9" />
            <rect x="70" y="56" width="118" height="6" fill="#94a3b8" />
            <rect x="70" y="68" width="90" height="6" fill="#cbd5e1" />
        </svg>
    ),
};

export default function LayoutPreviewCard({ id, label, desc, active, onClick }) {
    const [hover, setHover] = useState(false);
    return (
        <div className="relative" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
            <button
                onClick={onClick}
                className={`text-left p-3 rounded-xl border-2 transition w-full ${active ? 'border-blue-500 bg-blue-50' : 'border-slate-200 hover:border-slate-300'}`}
            >
                <Layout size={16} className="mb-1 text-slate-500" />
                <p className="text-sm font-bold text-slate-800">{label}</p>
                <p className="text-xs text-slate-400">{desc}</p>
            </button>

            {hover && (
                <div className="absolute z-50 left-1/2 -translate-x-1/2 bottom-full mb-2 w-52 rounded-xl shadow-2xl border border-slate-200 overflow-hidden bg-white animate-fadeIn">
                    <div className="aspect-[200/130]">{MINI_MOCKUPS[id]}</div>
                    <p className="text-[10px] text-center py-1.5 font-semibold text-slate-500 bg-slate-50">{label} preview</p>
                </div>
            )}
        </div>
    );
}